import { render, staticRenderFns } from "./ReportDesigner.vue?vue&type=template&id=395a2e2e&"
import script from "./ReportDesigner.vue?vue&type=script&lang=js&"
export * from "./ReportDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports